import React from "react";

import { faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import { m } from "framer-motion";
import { twJoin } from "tailwind-merge";

import { FlowVersion, FlowVersionStatus } from "src/api/flowTypes";
import { Icon } from "src/base-components/Icon";
import { Select } from "src/base-components/Select";
import { DraftPill, PublishedPill } from "src/flow/Pills";

export const VersionSelector: React.FC<{
  selectedVersion: FlowVersion;
  onChange: (id: string) => void;
  otherAvailableVersions: FlowVersion[];
  onDelete: () => void;
}> = ({ selectedVersion, onChange, otherAvailableVersions, onDelete }) => {
  const versionToOption = (version: FlowVersion, isSelected = false) => {
    return (
      <div
        className={twJoin(
          "flex min-w-0 flex-1 items-center justify-between",
          isSelected ? "mr-3" : "mr-8",
        )}
      >
        <div className="mr-3 min-w-0 flex-1 truncate">{version.name}</div>
        <div className="h-5.5 flex-shrink-0 -translate-y-px">
          {version.status === FlowVersionStatus.PUBLISHED ? (
            <PublishedPill />
          ) : (
            <DraftPill />
          )}
        </div>
      </div>
    );
  };
  const options = otherAvailableVersions
    .map((v) => ({ key: v.id, value: versionToOption(v) }))
    .concat([
      {
        key: selectedVersion.id,
        value: versionToOption(selectedVersion, true),
      },
    ]);
  return (
    <m.div
      animate={{
        opacity: 1,
        transition: { delay: 0.15 },
      }}
      className="flex items-center"
      initial={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      layout
    >
      <div className="relative mr-3 min-w-0 flex-1">
        <Select
          options={options}
          value={selectedVersion.id}
          onChange={onChange}
        />
      </div>
      <Icon
        color="text-gray-600"
        icon={faTrashAlt}
        size="xs"
        onClick={onDelete}
      />
    </m.div>
  );
};
